/**
 * Interface pour la personnalisation des documents
 */
export interface DocumentCustomization {
  id?: number;

  // Logo
  logoUrl?: string;
  logoWidth?: number;
  logoPosition?: LogoPosition;

  // Couleurs
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  backgroundColor?: string;

  // Typographie
  fontFamily?: FontFamily;
  fontSize?: number;

  // Footer
  footerText?: string;
  showLegalFooter?: boolean;
  showPageNumber?: boolean;

  // Style des tableaux
  tableStyle?: TableStyle;
  showTableBorders?: boolean;

  // Sections optionnelles
  showPaymentConditions?: boolean;
  showBankDetails?: boolean;
  showInsuranceSection?: boolean;
  showQualifications?: boolean;

  // Mise en page
  pageMargin?: number;
  sectionSpacing?: number;

  // Métadonnées
  createdAt?: string;
  updatedAt?: string;
}

export type LogoPosition = 'LEFT' | 'CENTER' | 'RIGHT';
export type FontFamily = 'Helvetica' | 'Times New Roman' | 'Courier' | 'DejaVu Sans';
export type TableStyle = 'CLASSIC' | 'MODERN' | 'BOLD';

export const LOGO_POSITIONS: { value: LogoPosition; label: string }[] = [
  { value: 'LEFT', label: 'Gauche' },
  { value: 'CENTER', label: 'Centre' },
  { value: 'RIGHT', label: 'Droite' },
];

export const FONT_FAMILIES: { value: FontFamily; label: string }[] = [
  { value: 'Helvetica', label: 'Helvetica (Moderne)' },
  { value: 'Times New Roman', label: 'Times New Roman (Classique)' },
  { value: 'Courier', label: 'Courier (Technique)' },
  { value: 'DejaVu Sans', label: 'DejaVu Sans (Élégant)' },
];

export const TABLE_STYLES: { value: TableStyle; label: string; description: string }[] = [
  { value: 'CLASSIC', label: 'Classique', description: 'Lignes alternées' },
  { value: 'MODERN', label: 'Moderne', description: 'Bordures fines' },
  { value: 'BOLD', label: 'Audacieux', description: 'Bordures épaisses' },
];

/**
 * Valeurs par défaut
 */
export const DEFAULT_CUSTOMIZATION: DocumentCustomization = {
  logoWidth: 150,
  logoPosition: 'LEFT',
  primaryColor: '#2c3e50',
  secondaryColor: '#3498db',
  accentColor: '#e74c3c',
  backgroundColor: '#ecf0f1',
  fontFamily: 'Helvetica',
  fontSize: 10,
  showLegalFooter: true,
  showPageNumber: true,
  tableStyle: 'CLASSIC',
  showTableBorders: true,
  showPaymentConditions: true,
  showBankDetails: true,
  showInsuranceSection: true,
  showQualifications: true,
  pageMargin: 15,
  sectionSpacing: 5,
};

/**
 * Résultat de l'upload de logo
 */
export interface LogoUploadResponse {
  logoPath: string;
  originalFileName: string;
  fileSize: number;
  message: string;
}
